// 默认babel中需要的polyfill
import '@babel/polyfill';
// 导入自定义的polyfill
import '@/utils/polyfill.js';
import Vue from 'vue';
import App from './App.vue';
import HlsJsPlayer from 'xgplayer-hls.js';
import {Tab, Tabs , Empty,Overlay, Badge, RadioGroup, Radio, Swipe, SwipeItem, Grid, GridItem, Switch, SwipeCell, Loading, Slider, Stepper, ActionSheet, Col, Row, Tag, Picker, NavBar, Tabbar, TabbarItem, Form, Field, Lazyload, Toast, Button, Skeleton, Popup, List, PullRefresh, Checkbox, CheckboxGroup, Icon } from 'vant';
import router from "@/router/index";
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2';

// 导入bootstrap
import "bootstrap"
import "bootstrap/dist/css/bootstrap.css"
// 导入jquery
import $ from 'jquery'
import initApp from "./initApp";

/* 使用Kendo UI SpreadSheet */
// import '@progress/kendo-ui/js/kendo.spreadsheet';
// import '@progress/kendo-ui/js/messages/kendo.messages.zh-CN';
// import {
//   SpreadsheetInstaller
// } from '@progress/kendo-spreadsheet-vue-wrapper';

import Video from 'video.js'
import 'video.js/dist/video-js.css'
window.HlsJsPlayer = HlsJsPlayer;
Vue.prototype.$video = Video

// wow
import 'animate.css'

Vue.config.productionTip = false;
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Empty)
Vue.use(Overlay)
Vue.use(Badge)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Grid)
Vue.use(GridItem);
Vue.use(Switch);
Vue.use(SwipeCell);
Vue.use(Loading);
Vue.use(Slider);
Vue.use(Stepper);
Vue.use(ActionSheet);
Vue.use(Col);
Vue.use(Row);
Vue.use(Tag);
Vue.use(NavBar);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Picker);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Field);
Vue.use(Form);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Skeleton);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(VueClipboard);
//Vue.use(SpreadsheetInstaller);

initApp(Vue);


new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

